import React, { useState } from 'react';

import { Tr, Td, HStack, Text } from '@ecoinvent/ui';
import mixpanel from 'mixpanel-browser';
import { useParams } from 'react-router';

import CopyToClipboardButton from 'components/shared/CopyToClipboardButton';
import { useDatasetSession } from 'pages/Dataset/DatasetSessionContext';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';
import { formatNumericalValue } from 'utilities/numbers';

import { FilteredExchange } from './types';

type Props = { item: FilteredExchange; tourTarget?: string };

const LciResultRow = ({ item, tourTarget }: Props) => {
  const [isHovered, setIsHovered] = useState(false);
  const { spold_id } = useParams();
  const { increment } = useDatasetSession();

  return (
    <Tr onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-tour-target={tourTarget}>
      <Td pl={0}>{item.name}</Td>
      <Td>{`${item.compartment}, ${item.sub_compartment}`}</Td>
      <Td pr={0}>
        <HStack>
          <Text>
            {formatNumericalValue(item.amount)} {item.unit}
          </Text>
          <CopyToClipboardButton
            value={item.amount}
            opacity={isHovered ? 1 : 0}
            onValueCopied={() => {
              mixpanel.track(MIXPANEL_EVENTS.COPY_DATASET_VALUE, {
                spold_id,
                type: 'lci_result',
                exchange: item.originalName,
                compartment: `${item.compartment}, ${item.sub_compartment}`,
              });
              increment('copy_dataset_value_count');
              increment('lci_results_tab_action_count');
            }}
          />
        </HStack>
      </Td>
    </Tr>
  );
};

export default LciResultRow;
